import React from 'react'
import { message } from 'antd'
import { useHistory } from 'react-router-dom'
import { useLocalization } from '@contexts/LocalizationContext'
import PageLayout from '@layouts/PageLayout'
import FormComponent from './Form'
import { client } from '@utils/client'

const Create = () => {
  const history = useHistory()
  const { t } = useLocalization()

  const handleSubmit = async (data) => {
    try {
      await client.post('/specialist', data)
      message.success('สำเร็จ')
      history.push('/specialties')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  return (
    <PageLayout title={t('specialty.createScreen.title')} extra={[]}>
      <FormComponent handleSubmit={handleSubmit} />
    </PageLayout>
  )
}

export default Create
